import { styled } from '@mui/material'
import config from '../../config'

const ClientLogo = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: config.mapAppBarHeight,
  right: 0,
  marginRight: theme.spacing(1.5),
  marginTop: theme.spacing(1.5),
  padding: theme.spacing(1),
  backgroundColor: 'white',
  opacity: 0.9,
  borderRadius: '5px',
  width: `auto`,
  height: `50px`,
  zIndex: 1000,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))

export default ClientLogo
